"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LastPage_exports = {};
__export(LastPage_exports, {
  default: () => LastPage_default
});
module.exports = __toCommonJS(LastPage_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.75391 13.7266L9.21094 10.25L5.75391 6.77344C5.58464 6.60417 5.5 6.39583 5.5 6.14844C5.5 5.90104 5.58464 5.6862 5.75391 5.50391C5.92318 5.33464 6.13151 5.25 6.37891 5.25C6.6263 5.25 6.83464 5.33464 7.00391 5.50391L11.0664 9.625C11.2487 9.79427 11.3398 10.0026 11.3398 10.25C11.3398 10.4974 11.2487 10.7057 11.0664 10.875L7.00391 14.9961C6.83464 15.1654 6.6263 15.25 6.37891 15.25C6.13151 15.25 5.92318 15.1654 5.75391 14.9961C5.58464 14.8138 5.5 14.599 5.5 14.3516C5.5 14.1042 5.58464 13.8958 5.75391 13.7266ZM14.6602 5.25C14.8945 5.25 15.0898 5.33464 15.2461 5.50391C15.4154 5.66016 15.5 5.85547 15.5 6.08984V14.4102C15.5 14.6445 15.4154 14.8464 15.2461 15.0156C15.0898 15.1719 14.8945 15.25 14.6602 15.25C14.4388 15.25 14.2435 15.1719 14.0742 15.0156C13.918 14.8464 13.8398 14.6445 13.8398 14.4102V6.08984C13.8398 5.85547 13.918 5.66016 14.0742 5.50391C14.2435 5.33464 14.4388 5.25 14.6602 5.25Z",
      fill: "currentColor"
    }
  )
);
const SvgLastPage = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LastPage_default = SvgLastPage;
